<template>
  <Fragment>
    <SectionHeader
      :title="$t('reporting.mainTitle')"
      :projectSelect="companyUser.company_type == 'branch'"
      @selectProjectUuids="projectUuids = $event"
    />
    <ReportingBranch v-if="companyUser.company_type == 'branch'" :projectUuids="projectUuids" />
    <template v-if="companyUser.company_type == 'industry'">
      <div v-if="!companyUser.company.settings.reporting_type" class="company-settings-missing">
        <div class="alert alert-info">
          {{ $t('reporting.companySettingsMissing') }}
        </div>
      </div>
      <template v-else>
        <ReportingRUMS v-if="companyUser.company.settings.reporting_type == 'rums'" />
        <ReportingActions v-if="companyUser.company.settings.reporting_type == 'actions'" />
      </template>
    </template>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

import ReportingActions from '@/views/reporting/actions'
import ReportingBranch from '@/views/reporting/branch'
import ReportingRUMS from '@/views/reporting/rums'

import SectionHeader from '@/components/SectionHeader'

export default {
  name: 'Reporting',
  components: {
    Fragment,
    ReportingActions,
    ReportingBranch,
    ReportingRUMS,
    SectionHeader,
  },
  inject: ['companyUser'],
  data: () => ({
    projectUuids: null,
  }),
}
</script>

<style scoped lang="scss">
.company-settings-missing {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.25rem;
}
</style>
